import { makeStyles } from 'tss-react/mui';

export const NAV_HEIGHT = 133;

export interface Props {
  useTransition: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'SharedNav',
})(({ brandColors, breakpoints, zLevels, typography }, props) => ({
  navContainer: {
    left: 0,
    right: 0,
    background: 'rgba(0,0,0,0)',
    transition: props.useTransition
      ? 'background .25s, color .25s, height .25s, top .5s'
      : '',
    color: brandColors.offWhite,
    zIndex: zLevels.dropdown,
    maxHeight: typography.pxToRem(NAV_HEIGHT),
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  bannerContainer: {
    transition: 'height .25s',
  },
  navItem: {
    [breakpoints.up('md')]: {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'auto',
    },
  },
  dropdownContainer: {
    [breakpoints.up('md')]: {
      position: 'fixed',
      top: typography.pxToRem(125),
      left: 0,
      right: 0,
      borderBottom: '1px solid var(--Line, rgba(0, 0, 0, 0.20))',
    },
  },
  logoLinkOnLight: {
    fill: brandColors.primaryMain,
    '&:hover, &:focus': {
      fill: brandColors.mediumBlue,
    },
  },
  logoLinkOnDark: {
    fill: brandColors.white,
    '&:hover, &:focus': {
      fill: brandColors.offWhite,
    },
  },
  lightOpaqueContainer: {
    background: brandColors.tintsOffWhite60,
  },
  darkOpaqueContainer: {
    background: brandColors.tintsHeroBlue10,
  },
  onDarkText: {
    color: brandColors.white,
  },
  onLightText: {
    color: brandColors.black,
  },
  navBody: {
    display: 'flex',
    position: 'relative',
    padding: `${typography.pxToRem(16)} ${typography.pxToRem(24)}`,
    [breakpoints.up('sm')]: {
      padding: `${typography.pxToRem(16)} ${typography.pxToRem(40)}`,
    },
    [breakpoints.up('md')]: {
      padding: `0 ${typography.pxToRem(64)}`,
    },
    [breakpoints.up('lg')]: {
      padding: `0 ${typography.pxToRem(80)}`,
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    zIndex: zLevels.dropdown,
  },
  placeholder: {
    height: typography.pxToRem(NAV_HEIGHT),
    width: '100%',
  },
  helperNavContainer: {
    borderBottom: '1px solid var(--Line, rgba(0, 0, 0, 0.20))',
  },
}));

export default useStyles;
